import React from "react";
import { GovShareButton } from "@/components/governance/GovShare";
import { Badge } from "@/components/primitives";

const statusTone = (s) => (s === "active" ? "success" : "default");

// Rich committee-member sharing — supplies the member-specific preview card
// (identity + active membership) and the backend share path.
export const CommitteeShare = ({ coldId, d }) => {
  const status = d?.status || "—";
  const memberships = Array.isArray(d?.memberships) ? d.memberships : [];
  const current = memberships.find((m) => m.current) || null;

  return (
    <GovShareButton
      tid="committee"
      heading="Share this committee member"
      sharePath={`governance/committee/${coldId}`}
      title="Constitutional Committee Member"
      tweetText="Constitutional Committee member · Cardano governance on Ada Explorer"
    >
      <div className="flex items-center justify-between gap-3">
        <span className="text-[9px] uppercase tracking-[0.25em] mono text-[#22d3ee]">ada explorer · governance</span>
        <Badge tone={statusTone(status)}>{status}</Badge>
      </div>
      <div className="text-[10px] uppercase tracking-[0.2em] mono text-[#22d3ee]/80">Constitutional Committee</div>
      <div className="text-[18px] font-heading font-semibold text-foreground leading-snug break-words">Committee Member</div>
      <div className="text-[10px] mono text-muted-foreground/70 break-all">{coldId}</div>
      <div className="pt-1 space-y-1">
        <div className="text-[9px] uppercase tracking-[0.2em] mono text-muted-foreground">Current membership</div>
        <div className="text-[12px] mono text-foreground">
          {current
            ? `Committee #${current.committee_id} · expires epoch ${current.expiration_epoch ?? "—"}`
            : "No active membership"}
        </div>
      </div>
    </GovShareButton>
  );
};
